module.exports = __webpack_public_path__ + "img/home_en_primeur_de.3c27457.png";